/* eslint-disable react/jsx-pascal-case */
import styled from "styled-components";
import theme, { Content_Text } from "./theme";
import ic_xmark from "../image/ic_xmark.png";
import ic_red_dot from "../image/ic_red_dot.png";
import { useEffect, useState } from "react";
import Privacy_Modal from "./Privacy_Modal";
import axios from "axios";

import ic_check_on from "../image/ic_check_on.png";
import ic_check_off from "../image/ic_check_off.png";

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  background-color: white;
  position: relative;
  width: 500px;
  height: 600px;
  padding: 25px 25px 15px 25px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 800px) {
    width: 300px;
    height: 600px;
    padding: 15px 15px 0px 15px;
  }
`;
const BarDiv = styled.div`
  margin-top: 15px;
  border-width: 0px 0px 1px 0px;
  border-color: #e7e7e7;
  border-style: solid;
  width: 100%;
`;

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  cursor: pointer;
`;

const CloseButton = styled(Image)`
  align-self: flex-end;
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  width: 20px;
  @media (max-width: 800px) {
    width: 15px;
  }
`;

const TitleDiv = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;
const NameInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 98%;
  margin-top: 10px;
  padding: 8px 5px;
`;

const PhoneInput = styled.input`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  width: 20%;
  margin-top: 10px;
  padding: 8px 5px;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const MemoInput = styled.textarea`
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.barGray};
  height: 100px;
  width: 96%;
  margin-top: 10px;
  padding: 10px;
  resize: none;
`;
const CheckBox = styled.input`
  appearance: none;
  border: 1.5px solid ${theme.colors.barGray};
  border-radius: 100px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;

  &:checked::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px; /* 내부 원의 크기 */
    height: 12px; /* 내부 원의 크기 */
    background-color: ${theme.colors.fontBlue2};
    border-radius: 100px;
  }
`;
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  position: absolute;
  bottom: 30px;
  @media (max-width: 800px) {
    bottom: 15px;
  }
`;
const Button = styled.button`
  background-color: ${(props) =>
    props.disabled ? theme.colors.barDarkGray : "#191919"};
  color: white;
  padding: 10px 30px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  border-width: 0px;
  border-radius: 8px;
  text-align: center;
  text-justify: center;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #777777;
  }
`;

const CheckBox_img = styled.img`
  width: 20px;
  cursor: pointer;
`;

function Apply_SSMS_Modal({ show, onClose, data }) {
  const [name, set_Name] = useState("");
  const [phone_f, set_Phone_f] = useState("");
  const [phone_s, set_Phone_s] = useState("");
  const [phone_t, set_Phone_t] = useState("");
  const [email, set_Email] = useState("");
  const [memo, set_Memo] = useState("");
  const [company, set_Company] = useState("");
  const [check, set_Check] = useState(false);
  const [modal, set_Modal] = useState(false);
  const [loading, set_Loading] = useState(false);
  const [platform, set_Platform] = useState("안전관리 플랫폼");
  const name_set = (event) => {
    set_Name(event.target.value);
  };
  const phone_f_set = (event) => {
    if (event.target.value.length < 4) {
      set_Phone_f(event.target.value);
    }
  };
  const phone_s_set = (event) => {
    if (event.target.value.length < 5) {
      set_Phone_s(event.target.value);
    }
  };
  const phone_t_set = (event) => {
    if (event.target.value.length < 5) {
      set_Phone_t(event.target.value);
    }
  };
  const email_set = (event) => {
    set_Email(event.target.value);
  };
  const memo_set = (event) => {
    set_Memo(event.target.value);
  };
  const company_set = (event) => {
    set_Company(event.target.value);
  };
  const open_Modal = () => {
    set_Modal(true);
  };
  const close_Modal = () => {
    set_Modal(false);
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
        close_Modal();
        set_Check(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  if (!show) {
    return null;
  }
  const send_mail = () => {
    const type = data === "pre" ? "premium" : "standard";
    const plat = data === "pre" ? "" : platform;
    if (!check) {
      alert("개인정보 수집 및 이용 동의에 동의해주세요.");
    } else if (
      name === "" ||
      phone_f === "" ||
      phone_s === "" ||
      phone_t === "" ||
      email === ""
    ) {
      alert("필수 입력 항목을 입력해주세요.");
    } else if (
      (email !== "" && !email.includes("@")) ||
      (email !== "" && !email.includes("."))
    ) {
      alert("이메일 주소를 확인해주세요.");
    } else {
      set_Loading(true);
      axios
        .post(
          "http://linkfms.kr/FMS/fms_system.php",
          {
            user_email: email,
            email_title: "SSMS 문의 - " + name,
            email_content:
              "이름 : " +
              name +
              "<br/>연락처 : " +
              phone_f +
              "-" +
              phone_s +
              "-" +
              phone_t +
              // "<br/>회사명 : " +
              // company +
              "<br/>플랫폼 : " +
              plat +
              "<br/>문의내용 : " +
              memo +
              "<br/>플랜 : " +
              type,
          },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        )
        .then(function (response) {
          alert("문의완료. 24시간내로 연락드릴게요!");
          onClose();
          set_Check(false);
          set_Loading(false);
        })
        .catch(function (error) {
          // console.log(error);
        });
    }

    // const subject = encodeURIComponent("신청서 제출");
    // const body = encodeURIComponent(
    //   `이름: ${name}\n` +
    //     `전화번호: ${phone_f}-${phone_s}-${phone_t}\n` +
    //     `이메일: ${email}\n` +
    //     `메모: ${memo}`
    // );
    // window.location.href = `mailto:colaage2323@gmail.com?subject=${subject}&body=${body}`;
  };
  const Close = () => {
    onClose();
    set_Check(false);
  };
  return (
    <ModalBackground>
      <ModalContainer>
        <CloseButton
          onClick={Close}
          src={ic_xmark}
          alt={ic_xmark}
        ></CloseButton>
        <Content_Text $large $xbold>
          신청하기
        </Content_Text>
        <BarDiv />

        {data === "stan" && (
          <>
            <TitleDiv>
              <Content_Text $xbold $xsmall>
                플랫폼
              </Content_Text>
            </TitleDiv>
            <TitleDiv style={{ marginTop: 10 }}>
              <CheckBox_img
                onClick={() => {
                  set_Platform("안전관리 플랫폼");
                }}
                src={
                  platform === "안전관리 플랫폼" ? ic_check_on : ic_check_off
                }
              />
              <Content_Text $xsmall $bold>
                &nbsp;&nbsp;안전관리 플랫폼
              </Content_Text>
            </TitleDiv>
          </>
        )}
        <TitleDiv>
          <Content_Text $xbold $xsmall>
            이름
          </Content_Text>
          <img
            style={{ height: 5, marginLeft: 5 }}
            src={ic_red_dot}
            alt={ic_red_dot}
          />
        </TitleDiv>
        <NameInput onChange={name_set} value={name} type="text" />
        <TitleDiv>
          <Content_Text $xbold $xsmall>
            연락처
          </Content_Text>
          <img
            style={{ height: 5, marginLeft: 5 }}
            src={ic_red_dot}
            alt={ic_red_dot}
          />
        </TitleDiv>
        <div>
          <PhoneInput onChange={phone_f_set} value={phone_f} type="number" />
          {" - "}
          <PhoneInput onChange={phone_s_set} value={phone_s} type="number" />
          {" - "}
          <PhoneInput onChange={phone_t_set} value={phone_t} type="number" />
        </div>
        <TitleDiv>
          <Content_Text $xbold $xsmall>
            이메일
          </Content_Text>
          <img
            style={{ height: 5, marginLeft: 5 }}
            src={ic_red_dot}
            alt={ic_red_dot}
          />
        </TitleDiv>
        <NameInput onChange={email_set} value={email} type="text" />
        {/* <TitleDiv>
          <Content_Text $xbold $xsmall>
            회사명
          </Content_Text>
        </TitleDiv>
        <NameInput onChange={company_set} value={company} type="text" /> */}
        <TitleDiv>
          <Content_Text $xbold $xsmall>
            문의내용
          </Content_Text>
        </TitleDiv>
        <MemoInput onChange={memo_set} value={memo} type="text" />
        <TitleDiv>
          <CheckBox
            type="checkbox"
            onClick={() => {
              set_Check(!check);
            }}
          />
          <Content_Text $xsmall $bold>
            개인정보 수집 및 이용 동의
          </Content_Text>
          <Content_Text
            $xxsmall
            $lightGray
            style={{ cursor: "pointer" }}
            onClick={open_Modal}
          >
            [자세히보기]
          </Content_Text>
        </TitleDiv>
        <ModalFooter>
          <Button disabled={loading} onClick={send_mail}>
            신청하기
          </Button>
        </ModalFooter>
      </ModalContainer>
      <Privacy_Modal show={modal} onClose={close_Modal} />
    </ModalBackground>
  );
}
export default Apply_SSMS_Modal;
